/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { VestingVesta, VestingVestaInterface } from "../VestingVesta";

const _abi = [
  {
    type: "function",
    name: "NAME",
    inputs: [],
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "SIX_MONTHS",
    inputs: [],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "TWO_YEARS",
    inputs: [],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "addEntityVesting",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalSupply",
        type: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addEntityVestingWithConfig",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lockClaimingTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_vestingDurationTimestamp",
        type: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addSupplyToEntityVesting",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_extraSupply",
        type: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "admins",
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "assignedVSTATokens",
    inputs: [],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "claimVSTAToken",
    inputs: [
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "entitiesVesting",
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    outputs: [
      {
        internalType: "uint256",
        name: "createdDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startVestingDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endVestingDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "claimed",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getClaimableVSTA",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
    ],
    outputs: [
      {
        internalType: "uint256",
        name: "claimable",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getEntityVestingLeft",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
    ],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getEntityVestingTotalSupply",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
    ],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getUnassignVSTATokensAmount",
    inputs: [],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isEntityExits",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
    ],
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "lowerEntityVesting",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_newTotalSupply",
        type: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "removeEntityVesting",
    inputs: [
      {
        internalType: "address",
        name: "_entity",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingType",
        type: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setAdmin",
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_status",
        type: "bool",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setUp",
    inputs: [
      {
        internalType: "address",
        name: "_vstaAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_whitelistAddr",
        type: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferUnassignedVSTA",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "vstaToken",
    inputs: [],
    outputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "ClaimingLockHigherThanVestingLock",
    inputs: [],
  },
  {
    type: "error",
    name: "DuplicatedVestingRule",
    inputs: [],
  },
  {
    type: "error",
    name: "EntityNotFound",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidAddress",
    inputs: [],
  },
  {
    type: "error",
    name: "NewSupplyGoesToZero",
    inputs: [],
  },
  {
    type: "error",
    name: "NewSupplyHigherOnReduceMethod",
    inputs: [],
  },
  {
    type: "error",
    name: "NoPermission",
    inputs: [],
  },
  {
    type: "error",
    name: "SupplyCannotBeZero",
    inputs: [],
  },
  {
    type: "error",
    name: "VestingTimestampLowerThanBlockTimestamp",
    inputs: [],
  },
] as const;

export class VestingVesta__factory {
  static readonly abi = _abi;
  static createInterface(): VestingVestaInterface {
    return new utils.Interface(_abi) as VestingVestaInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VestingVesta {
    return new Contract(address, _abi, signerOrProvider) as VestingVesta;
  }
}
